import _ from "lodash";
import React, { createRef } from "react";
import classes from "./MediaPlaceholder.scss";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import PropTypes from "prop-types";
import { SpeakerIcon, LockIconV2, PlayIconV2 } from "SvgComponents";
import {
  DownloadCloudOutlined,
  WorkbookOutlined,
  ExpandArrowsFourOutlined,
  LinkOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PlayFilled,
  AudioColored,
  PageSquareColored,
  VideoColored,
  ImageColored,
  PdfColored,
  ZipFileColored,
  FilenotfoundColored,
  SlidesColored,
  SheetsColored,
  WorkbookColored,
  LinkColored,
  NoteColored,
  WorksheetClipboardOutlined,
  PencilLineOutlined,
  MoveArrowsOutlined,
  PageFoldPortraitOutlined,
} from "@toddle-edu/ds-icons";
import { IconButton, Tag, Button, Tooltip } from "@toddle-edu/ds-web";
import {
  colors,
  PLACEHOLDER_RECT_IMAGE,
  PLACEHOLDER_RECT_IMAGE_COUNT,
} from "Constants";
import ScalableView from "UIComponents/ScalableView";
import SlickSlider from "UIComponents/SlickSlider";
import AudioPlayer from "UIComponents/AudioPlayer";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import VideoPlayer from "UIComponents/VideoPlayer";
import I18nHOC from "UIComponents/I18nHOC";
import EmbedVideoPlayer from "UIComponents/EmbedVideoPlayer";
import AudioWaveformPlayer from "UIComponents/AudioWaveformPlayer";
import CompactAudioWaveformPlayer from "UIComponents/CompactAudioWaveformPlayer";
import {
  getThumbUrl,
  isImageCarousel,
  hasAudioNote,
  getCommentDisplayContent,
  addHttpsInUrl,
  getAttachmentsByTypeFromAttachmentArr,
  getFileThumbUrl,
  getStyleStrippedText,
  getYoutubeVideoId,
  isTouchableV2,
} from "Utils";
import { connect } from "react-redux";
import { downloadFromUrl, removeProgressElement } from "modules/Services";
import AttachmentList from "AppComponents/Attachment/AttachmentList";
import classNames from "classnames";
import { getStudentResponseData } from "ClassRoom/modules/utils";
import { compose } from "lib/apolloClient";
import { Trans } from "react-i18next";
import ReactPlayer from "react-player";
import IframeWrapper from "UIComponents/FileViewer/IframeWrapper/IframeWrapper";
import moment from "moment";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { onEnterOrSpaceKeyDown } from "Utils";
import { AudioWaveformPlayerV2 } from "../AudioWaveformPlayerV2/AudioWaveformPlayerV2";
import {
  getShowYtLinkInTheatreMode,
  getIsYoutubeLink,
  getNormalizeYouTubeUrl,
  isNewNotesUi,
} from "Post/utils";

const BLANK_OBJECT = {};
const styles = {
  attachmentMediaStyle: { display: "block" },
};
class MediaPlaceholder extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLinkVideoPlaying: false,
      audioLoaded: false,
      isAttachmentCountVisible: false,
      showAudioWaveformPlayerV2: false,
    };
    this.embedPlayerRef = createRef();
  }

  componentDidMount() {
    if (this.props.getEmbedPlayerRef) {
      this.props.getEmbedPlayerRef(this.embedPlayerRef?.current);
    }
  }
  isLocalUrl = url => {
    return _.includes(url, "blob");
  };

  setAttachmentCountVisible(value) {
    this.setState({ isAttachmentCountVisible: value });
  }

  getThumbResolution = ({
    imageHeight,
    imageMaxWidth,
    resolutionMutliplier,
    fitIn,
  }) => {
    if (!fitIn) {
      return {
        width: imageMaxWidth * resolutionMutliplier,
        height: imageHeight * resolutionMutliplier,
      };
    } else {
      const heightValue =
        Math.ceil((imageMaxWidth * resolutionMutliplier) / 256) * 256;
      const widthValue =
        Math.ceil((imageHeight * resolutionMutliplier) / 256) * 256;
      const value = Math.max(heightValue, widthValue);

      return {
        width: value,
        height: value,
      };
    }
  };

  onDeleteClick = attachment => {
    if (this.props.deleteAttachment) {
      this.props.deleteAttachment(attachment);
    }
  };

  withDownload = ({ downloadFromUrl, downloadVariable }) => {
    return event => {
      onEnterOrSpaceKeyDown(event, () => {
        event.stopPropagation();
        downloadFromUrl(downloadVariable);
      });
    };
  };

  handleDeleteKeyDown = attachment => {
    return event =>
      onEnterOrSpaceKeyDown(event, () => {
        event.stopPropagation();
        this.onDeleteClick(attachment);
      });
  };

  attachmentActionsSvgs = attachment => {
    const { type } = attachment;
    const {
      iconContainerStyle,
      downloadFromUrl,
      mode,
      isAttachmentCreated,
      showDownloadIcon,
      postEntityItems,
      showDeleteIconOnTopCorner = false,
      testId,
      isDownloadEnabled,
    } = this.props;

    const hasPostEntityItems = !_.isEmpty(postEntityItems);
    const typeButton =
      type == "WORKBOOK" ? "workbook" : type == "VIDEO" ? "play" : "expand";

    return (
      <div className={classes.svgContainer}>
        {isAttachmentCreated &&
        isDownloadEnabled &&
        mode != "edit" &&
        showDownloadIcon &&
        !hasPostEntityItems ? (
          <div
            onClick={e => {
              e.stopPropagation();
              downloadFromUrl({
                attachment: attachment,
                shouldAskForSave: true,
              });
            }}
            onKeyDown={this.withDownload({
              downloadFromUrl,
              downloadVariable: {
                attachment: attachment,
                shouldAskForSave: true,
              },
            })}
            className={classes.actionButton}
            style={iconContainerStyle}
            tabIndex={0}
            data-test-id={`${testId}-download-button`}
          >
            <div className={classes.actionSvgIcon}>
              <div className={classes.downloadIcon}>
                <DownloadCloudOutlined variant={"on"} size={"xxx-small"} />
              </div>
            </div>
          </div>
        ) : null}
        {isAttachmentCreated && mode == "edit" && !showDeleteIconOnTopCorner && (
          <div
            onClick={e => {
              e.stopPropagation();
              this.onDeleteClick(attachment);
            }}
            className={classes.actionButton}
            data-test-id={`${testId}-${_.camelCase(
              attachment?.type
            )}Delete-button`}
            style={iconContainerStyle}
            tabIndex={0}
            onKeyDown={this.handleDeleteKeyDown(attachment)}
          >
            <div className={classes.actionSvgIcon}>
              <DeleteOutlined variant={"on"} size={"xxx-small"} />
            </div>
          </div>
        )}
        <div
          className={classes.actionButton}
          style={iconContainerStyle}
          onClick={this.props.onClickMedia}
          tabIndex={0}
          data-test-id={`${testId}-${_.camelCase(
            attachment?.type
          )}-${typeButton}Button`}
        >
          <div className={classes.actionSvgIcon}>
            {type == "VIDEO" ? (
              <PlayIconV2
                fill={colors.strokeTwo}
                width={"33%"}
                height={"33%"}
                style={{ maxWidth: "20px", maxHeight: "24px" }}
              />
            ) : type == "WORKBOOK" ? (
              <WorkbookOutlined size="xxx-small" variant="on" />
            ) : (
              <ExpandArrowsFourOutlined size={"xxx-small"} variant={"on"} />
            )}
          </div>
        </div>
      </div>
    );
  };

  getCenterSvgDetails = ({ type, url }) => {
    let svgIcon = null;
    switch (type) {
      case "IMAGE":
        svgIcon = null;
        break;
      case "WORKBOOK":
        svgIcon = <WorkbookOutlined size="xxx-small" variant="on" />;
        break;
      case "FILE":
        svgIcon = null;
        break;
      // svgIcon = (
      //   <PdfLineIcon width={"33%"} height={"33%"} fill={colors.white} />
      // );
      case "VIDEO":
      case "AUDIO":
        svgIcon = _.get(this.props, "showOverlayIcons", false) ? (
          <PlayIconV2
            width={"33%"}
            height={"33%"}
            style={{ maxWidth: "16px", maxHeight: "18px" }}
          />
        ) : (
          <IconButton
            variant={"dark"}
            size={"medium"}
            icon={<PlayFilled variant="on" />}
          />
        );
        break;
      case "LINK":
        svgIcon = ReactPlayer.canPlay(url) ? (
          <PlayIconV2
            width={"33%"}
            height={"33%"}
            fill={colors.strokeTwo}
            style={{ maxWidth: "16px", maxHeight: "18px" }}
          />
        ) : (
          <LinkOutlined variant={"on"} size={"xxx-small"} />
        );
        break;
      case "TODDLE_DOC":
        svgIcon = (
          <PageFoldPortraitOutlined
            style={{
              color: "var(--decorative-foreground-subtle-blue)",
            }}
            size={"x-small"}
          />
        );
        break;
      default:
        break;
    }
    return svgIcon;
  };

  startDownloadFile = ({ attachment }) => {
    const { downloadFromUrl } = this.props;

    downloadFromUrl({ attachment, shouldAskForSave: true });
  };

  onClickFileContainer = e => {
    const { showDownloadBeginOverlay } = this.props;

    showDownloadBeginOverlay && e.stopPropagation();
  };

  audioFileDownload = attachment => {
    const { downloadFromUrl, removeProgressElement } = this.props;
    let name = _.get(attachment, "name", "");
    if (_.isEmpty(name)) {
      name = "toddle_audio_" + moment().format("DD-MM-YY_h_mm");
    }

    const id = "Toddle_audio_#123";

    downloadFromUrl({
      name: name,
      attachment: attachment,
      shouldAskForSave: true,
      fileUploadId: id,
    }).then(() => {
      removeProgressElement({ id });
    });
  };

  getFormattedFileType = fileType => {
    if (_.isEqual(fileType, "PDF")) return fileType;
    if (_.isEqual(fileType, "TODDLE_DOC"))
      return this.props.t("classRoom:toddle_doc_capitalized");
    return _.startCase(_.toLower(fileType));
  };

  getIconByFileType = ({ fileType, fileIconSize = "x-small" }) => {
    let icon = <FilenotfoundColored size={fileIconSize} />;
    switch (fileType) {
      case "IMAGE":
        icon = <ImageColored size={fileIconSize} />;
        break;
      case "VIDEO":
        icon = <VideoColored size={fileIconSize} />;
        break;
      case "AUDIO":
        icon = <AudioColored size={fileIconSize} />;
        break;
      case "PDF":
        icon = <PdfColored size={fileIconSize} />;
        break;
      case "DOCUMENT":
        icon = <PageSquareColored size={fileIconSize} />;
        break;
      case "SHEET":
        icon = <SheetsColored size={fileIconSize} />;
        break;
      case "SLIDES":
        icon = <SlidesColored size={fileIconSize} />;
        break;
      case "ZIP":
        icon = <ZipFileColored size={fileIconSize} />;
        break;
      case "WORKBOOK":
        icon = <WorkbookColored size={fileIconSize} />;
        break;
      case "LINK":
        icon = <LinkColored size={fileIconSize} />;
        break;
      case "NOTE":
        icon = <NoteColored size={fileIconSize} />;
        break;
      case "QUESTION":
      case "QUESTION_SUBMISSION":
      case "WORKSHEET":
        icon = <WorksheetClipboardOutlined size={fileIconSize} />;
        break;
      case "TODDLE_DOC":
        icon = (
          <PageFoldPortraitOutlined
            style={{
              color: "var(--decorative-foreground-subtle-violet)",
            }}
            size={fileIconSize}
          />
        );
        break;
      case "FILE":
      case "UNKNOWN":
        icon = <FilenotfoundColored size={fileIconSize} />;
        break;
    }
    return icon;
  };
  getIconCardByFileType = ({
    fileType,
    itemStyles = {},
    containerStyle = {},
  }) => {
    const { fileIconSize, extensionTextStyle } = this.props;
    const icon = this.getIconByFileType({
      fileType,
      fileIconSize: fileIconSize,
    });
    return (
      <div
        className={classes.iconCardContainer}
        style={{ ...containerStyle, ...itemStyles }}
      >
        <div className={classes.iconBackground}>
          {icon}
          <div
            className={classes.extentionContainer}
            style={extensionTextStyle}
          >
            {this.getFormattedFileType(fileType)}
          </div>
        </div>
      </div>
    );
  };
  getMediaRender = attachment => {
    let mediaToRender;
    const {
      imageMaxWidth,
      imageMaxHeight,
      resolutionMutliplier,
      fitIn,
      backgroundSize,
      scalableRatio,
      itemStyles,
      containerStyle,
      showVideoPlayer,
      showFullscreenImage,
      toolTipText,
      isDisabledMode,
      showLinkInNewTab,
      noteContainerStyle,
      noteContainerWithLimitStyles,
      showDownloadBeginOverlay,
      isUploading,
      isLastAttachment,
      isStudentResponse,
      showIconCardsWithExtension,
      showBorderOnHover,
      videoPlayerRef,
      videoPlaybackTime,
      audioPlayerRef,
      audioPlaybackTime,
      noteLinesContainerStyles,
      showExtensionOnCornerByHover,
      showOverlayIcons,
      showVideoPlayerV2,
      useLazyVideoPlayer,
      isolateSpacebarControl,
      showAudioDownloadButton,
      testId,
      isDownloadEnabled,
    } = this.props;
    const imageHeight = imageMaxHeight;

    const downloadBeginOverlayClass = classNames(
      { [classes.downloadBeginOverlay]: true },
      { [classes.downloadBeginAnimation]: showDownloadBeginOverlay }
    );

    const { thumbUrl: rethumbImage, isIcon, color, fileType } = getThumbUrl({
      ...this.getThumbResolution({
        imageMaxWidth,
        imageHeight,
        resolutionMutliplier,
        fitIn,
      }),
      attachment,
      fitIn,
      cardType: "vertical",
    });

    let updatedItemStyles = itemStyles;

    if (isIcon) {
      updatedItemStyles = {
        backgroundSize: "20%",
        backgroundPosition: "center",
        backgroundColor: color,
      };
      if (showIconCardsWithExtension) {
        const attachmentType = _.get(attachment, "type", "");
        if (fileType && fileType != "NOTE") {
          updatedItemStyles = {
            height: "50vh",
            border: isStudentResponse
              ? "none"
              : `1px solid ${colors.borderSubtle}`,
            ...itemStyles,
          };

          mediaToRender = this.getIconCardByFileType({
            fileType,
            itemStyles: updatedItemStyles,
            containerStyle,
            attachment,
          });
          if (attachmentType == "VIDEO") {
            if (!showVideoPlayer) return mediaToRender;
          } else {
            return mediaToRender;
          }
        }
      }
    }

    const onAudioFileDownload = e => {
      e.stopPropagation();
      this.audioFileDownload(attachment);
    };

    const isMediaUploading = isUploading && isLastAttachment;
    const audioWrapperClass = classNames(
      {
        [classes.audioWrapper]:
          !isStudentResponse && !showIconCardsWithExtension,
      },
      { [classes.audioWrapperUploading]: isMediaUploading }
    );

    const audioSpeakerIconContainer = classNames(
      { [classes.audioSpeakerIconContainer]: true },
      { [classes.borderOnHover]: showBorderOnHover }
    );

    const imageContainerClass = classNames(
      { [classes.imageContainer]: true },
      { [classes.borderOnHover]: showBorderOnHover }
    );

    const updateEmbedPlayerRef = ref => {
      if (this.embedPlayerRef) this.embedPlayerRef.current = ref;
    };

    const updateAudioPlayerRef = ref => {
      if (!_.isNil(audioPlayerRef)) audioPlayerRef.current = ref;
      this._audioPlayerRef = ref;
    };

    // set state to audio loaded when audio is loaded
    const audioLoaded = () => {
      this.setState({ audioLoaded: true });
    };

    const updateVideoPlayerRef = ref => {
      if (!_.isNil(videoPlayerRef)) videoPlayerRef.current = ref;
    };
    const sourceWidth = _.get(attachment.metadata, "width", 556) || 556;
    const sourceHeight = _.get(attachment.metadata, "height", 288) || 288;
    const attachmentUrl = _.get(attachment, "url", "");
    const streamVideoUrl = _.get(attachment, "streamUrl", "");
    const cardType = this.getCardType();
    const {
      attachmentSize,
      showAttachmentCounterTag,
      attachmentIndex,
      isAttachmentCountVisible,
    } = this.props;

    const altname = _.get(attachment, "name", "") ?? "";

    switch (_.get(attachment, "type")) {
      case "IMAGE":
      case "WORKBOOK":
        mediaToRender = showFullscreenImage ? ( // if showFullscreenImage is true render image in img tag else render ScalableView
          <div
            tabIndex={0}
            style={{
              ...updatedItemStyles,
            }}
            className={imageContainerClass}
          >
            <img
              src={rethumbImage}
              alt={altname}
              style={{ width: "100%" }}
            ></img>
            {this.renderIconContainer(attachment)}
          </div>
        ) : (
          <ScalableView
            width={imageMaxWidth}
            maxHeight={imageHeight}
            sourceWidth={sourceWidth}
            sourceHeight={sourceHeight}
            scalableRatio={scalableRatio}
            containerStyle={containerStyle}
          >
            <div
              tabIndex={0}
              style={{
                backgroundImage: `url('${rethumbImage}')`,
                backgroundSize,
                ...updatedItemStyles,
              }}
              className={imageContainerClass}
            >
              {this.renderIconContainer(attachment)}
              {showAttachmentCounterTag ? (
                <div
                  className={`${classes.attachmentCounter} ${
                    isAttachmentCountVisible
                      ? classes.attachmentCounterVisible
                      : classes.attachmentCounterHidden
                  }`}
                >{`${attachmentIndex + 1}/${attachmentSize}`}</div>
              ) : null}
            </div>
          </ScalableView>
        );

        break;
      case "AUDIO": {
        const {
          showFileName,
          mode,
          showWaveform,
          showAudioWaveformPlayerV2,
          pausedRecordingState,
          showCompactAudioWaveformPlayer,
          isAppearanceLikeMediaCard,
          playAudioOnSeek,
          shouldBeResponsive,
        } = this.props;
        const renderAudioDownloadButton =
          mode === "view" && isDownloadEnabled && showAudioDownloadButton;
        mediaToRender = (
          <div className={audioWrapperClass} style={{ ...containerStyle }}>
            {cardType == "small" ? (
              isStudentResponse || showIconCardsWithExtension ? (
                <div
                  className={audioSpeakerIconContainer}
                  style={{ ...containerStyle, ...itemStyles }}
                >
                  <div className={classes.audioSpeakerIconBackground}>
                    <AudioColored size="large" />
                    {"Audio"}
                  </div>
                </div>
              ) : (
                this.renderIconContainer(attachment)
              )
            ) : (
              <div
                data-test-id={`${this.props.testId}-container`}
                className={classes.audioPlayerWrapper}
                style={{
                  paddingRight: mode == "edit" ? 40 : 0,
                }}
              >
                {showCompactAudioWaveformPlayer ? (
                  <CompactAudioWaveformPlayer
                    attachment={attachment}
                    audioLoaded={audioLoaded}
                    isUploading={isMediaUploading}
                    ref={updateAudioPlayerRef}
                    audioPlaybackTime={audioPlaybackTime}
                    pausedRecordingState={pausedRecordingState}
                    isAppearanceLikeMediaCard={isAppearanceLikeMediaCard}
                  />
                ) : showAudioWaveformPlayerV2 ? (
                  <AudioWaveformPlayerV2
                    attachment={attachment}
                    audioLoaded={audioLoaded}
                    isUploading={isMediaUploading}
                    ref={updateAudioPlayerRef}
                    audioPlaybackTime={audioPlaybackTime}
                    onAudioDownload={
                      renderAudioDownloadButton ? onAudioFileDownload : null
                    }
                    pausedRecordingState={pausedRecordingState}
                    testId={testId}
                    shouldBeResponsive={shouldBeResponsive}
                  />
                ) : showWaveform ? (
                  <AudioWaveformPlayer
                    attachment={attachment}
                    audioLoaded={audioLoaded}
                    isUploading={isMediaUploading}
                    ref={updateAudioPlayerRef}
                    audioPlaybackTime={audioPlaybackTime}
                    testId={testId}
                    playAudioOnSeek={playAudioOnSeek}
                  />
                ) : (
                  <AudioPlayer
                    attachment={attachment}
                    showFileName={showFileName}
                    ref={updateAudioPlayerRef}
                    audioPlaybackTime={audioPlaybackTime}
                    isUploading={isMediaUploading}
                    testId={testId}
                  ></AudioPlayer>
                )}
                {renderAudioDownloadButton &&
                !showAudioWaveformPlayerV2 &&
                !showCompactAudioWaveformPlayer ? (
                  <div
                    className={classes.audioSvgIcon}
                    onClick={onAudioFileDownload}
                  >
                    <div className={classes.downloadIcon}>
                      <IconButton
                        testId={`${testId}-audioPlayer-audioDownload`}
                        icon={<DownloadOutlined size={"xx-small"} />}
                        _legacy_variant={"plain"}
                        variant="neutral"
                        type="plain"
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        );

        break;
      }
      case "VIDEO":
        mediaToRender = (
          <ScalableView
            width={imageMaxWidth}
            maxHeight={imageMaxHeight}
            sourceWidth={sourceWidth}
            sourceHeight={sourceHeight}
            scalableRatio={scalableRatio}
            containerStyle={containerStyle}
          >
            {showVideoPlayer ? (
              <VideoPlayer
                videoUrl={streamVideoUrl ? streamVideoUrl : attachmentUrl}
                isHLSUrl={!!streamVideoUrl}
                getPlayerRef={updateVideoPlayerRef}
                videoPlaybackTime={videoPlaybackTime}
                showVideoPlayerV2={showVideoPlayerV2}
                useLazyVideoPlayer={useLazyVideoPlayer}
                isolateSpacebarControl={isolateSpacebarControl}
              />
            ) : (
              <div
                tabIndex={0}
                style={{
                  backgroundImage: `url('${rethumbImage}')`,
                  backgroundSize: backgroundSize,
                  ...updatedItemStyles,
                }}
                className={imageContainerClass}
              >
                {this.renderIconContainer(attachment)}
                {showAttachmentCounterTag ? (
                  <div
                    className={`${classes.attachmentCounter} ${
                      isAttachmentCountVisible
                        ? classes.attachmentCounterVisible
                        : classes.attachmentCounterHidden
                    }`}
                  >{`${attachmentIndex + 1}/${attachmentSize}`}</div>
                ) : null}
              </div>
            )}
          </ScalableView>
        );
        break;
      case "LINK": {
        const linkUrl = addHttpsInUrl(_.get(attachment, "url", ""));
        const isVideoLink = ReactPlayer.canPlay(linkUrl);
        const isShowYtLinkInTheatreMode = getShowYtLinkInTheatreMode();
        const isYoutubeLink =
          isShowYtLinkInTheatreMode &&
          getIsYoutubeLink(_.get(attachment, "url"));
        const SEESAW_REGEX = /https:\/\/app\.seesaw\.me\/#\/item\/item\.([A-Za-z]+|[0-9]*|-*)+\/share\/([A-Za-z])+/;
        const isSeesawLink = SEESAW_REGEX.test(linkUrl);
        const isDefaultLinkImage = _.includes(rethumbImage, "linkDefaultImage");

        mediaToRender = isYoutubeLink ? (
          <ScalableView
            width={imageMaxWidth}
            maxHeight={imageMaxHeight}
            sourceWidth={sourceWidth}
            sourceHeight={sourceHeight}
            scalableRatio={scalableRatio}
            containerStyle={containerStyle}
          >
            {showVideoPlayer ? (
              <VideoPlayer
                videoUrl={
                  streamVideoUrl
                    ? streamVideoUrl
                    : getNormalizeYouTubeUrl(attachmentUrl)
                }
                isHLSUrl={!!streamVideoUrl || isYoutubeLink}
                getPlayerRef={updateVideoPlayerRef}
                videoPlaybackTime={videoPlaybackTime}
                showVideoPlayerV2={showVideoPlayerV2}
                useLazyVideoPlayer={useLazyVideoPlayer}
                isolateSpacebarControl={isolateSpacebarControl}
              />
            ) : (
              <div
                tabIndex={0}
                style={{
                  backgroundImage: `url('${
                    getShowYtLinkInTheatreMode() &&
                    _.includes(
                      rethumbImage,
                      "/assets/images/linkDefaultImage.png"
                    )
                      ? `https://img.youtube.com/vi/${getYoutubeVideoId(
                          attachment.url
                        )}/maxresdefault.jpg`
                      : rethumbImage
                  }')`,
                  backgroundSize: backgroundSize,
                  ...updatedItemStyles,
                }}
                className={imageContainerClass}
              >
                {this.renderIconContainer(attachment)}
                {showAttachmentCounterTag ? (
                  <div
                    className={`${classes.attachmentCounter} ${
                      isAttachmentCountVisible
                        ? classes.attachmentCounterVisible
                        : classes.attachmentCounterHidden
                    }`}
                  >{`${attachmentIndex + 1}/${attachmentSize}`}</div>
                ) : null}
              </div>
            )}
          </ScalableView>
        ) : (
          <ScalableView
            width={imageMaxWidth}
            maxHeight={imageMaxHeight}
            sourceWidth={sourceWidth}
            sourceHeight={sourceHeight}
            scalableRatio={scalableRatio}
            containerStyle={containerStyle}
          >
            {isVideoLink || isYoutubeLink ? (
              <EmbedVideoPlayer
                url={
                  isYoutubeLink
                    ? getNormalizeYouTubeUrl(attachmentUrl)
                    : attachmentUrl
                }
                thumbnail={rethumbImage}
                className={classes.imageContainer}
                onRef={updateEmbedPlayerRef}
                onDeleteClick={() => this.onDeleteClick(attachment)}
                itemStyle={itemStyles}
                showExtensionOnCornerByHover={showExtensionOnCornerByHover}
                showOverlayIcons={showOverlayIcons}
              />
            ) : isSeesawLink ? (
              <IframeWrapper
                iframeSrc={linkUrl}
                title={this.props.t("a11y:seesaw_embedded_content")}
              />
            ) : (
              <ConditionalWrapper
                // if showLinkInNewTab is true wrap whole card in <a> tag else wrap only bottom card in <a> tag
                condition={showLinkInNewTab}
                wrapper={({ children }) => (
                  <a target="_blank" rel="noopener noreferrer" href={linkUrl}>
                    {children}
                  </a>
                )}
              >
                {isDisabledMode ? (
                  <LinkWithTooltip
                    tooltip={toolTipText}
                    placement={"top"}
                    href={null}
                    alignConfig={{ offset: [300, 0] }}
                  >
                    <div
                      tabIndex={0}
                      style={{
                        backgroundImage: `url('${rethumbImage}')`,
                        backgroundSize: backgroundSize,
                        ...updatedItemStyles,
                        position: "relative",
                      }}
                      className={imageContainerClass}
                    >
                      <div className={classes.lockIcon}>
                        <LockIconV2
                          width={32}
                          height={32}
                          fill={colors.white}
                        />
                      </div>
                      <div className={classes.lockBackground} />
                    </div>
                  </LinkWithTooltip>
                ) : isDefaultLinkImage ? (
                  <div
                    tabIndex={0}
                    style={{
                      ...updatedItemStyles,
                    }}
                    className={classNames(
                      imageContainerClass,
                      classes.imageStyle
                    )}
                  >
                    <div className={classes.defaultLinkStyle}>
                      <LinkColored size="large" />
                    </div>
                    {this.renderIconContainer(attachment)}
                    {showAttachmentCounterTag ? (
                      <div
                        className={`${classes.attachmentCounter} ${
                          isAttachmentCountVisible
                            ? classes.attachmentCounterVisible
                            : classes.attachmentCounterHidden
                        }`}
                      >{`${attachmentIndex + 1}/${attachmentSize}`}</div>
                    ) : null}
                  </div>
                ) : (
                  <div
                    tabIndex={0}
                    style={{
                      backgroundImage: `url('${rethumbImage}')`,
                      ...updatedItemStyles,
                    }}
                    className={classNames(
                      imageContainerClass,
                      classes.linkStyle
                    )}
                  >
                    {this.renderIconContainer(attachment)}
                    {showAttachmentCounterTag ? (
                      <div
                        className={`${classes.attachmentCounter} ${
                          isAttachmentCountVisible
                            ? classes.attachmentCounterVisible
                            : classes.attachmentCounterHidden
                        }`}
                      >{`${attachmentIndex + 1}/${attachmentSize}`}</div>
                    ) : null}
                  </div>
                )}
              </ConditionalWrapper>
            )}
          </ScalableView>
        );
        break;
      }
      case "FILE":
        mediaToRender = (
          <ScalableView
            width={imageMaxWidth}
            maxHeight={imageMaxHeight}
            sourceWidth={sourceWidth}
            sourceHeight={sourceHeight}
            scalableRatio={scalableRatio}
            containerStyle={containerStyle}
          >
            <div
              tabIndex={0}
              style={{
                backgroundImage: `url('${rethumbImage}')`,
                backgroundSize: backgroundSize,
                ...updatedItemStyles,
                cursor: showDownloadBeginOverlay ? "default" : "pointer",
              }}
              className={imageContainerClass}
              onClick={this.onClickFileContainer}
            >
              {this.renderIconContainer(attachment)}
              {showAttachmentCounterTag ? (
                <div
                  className={`${classes.attachmentCounter} ${
                    isAttachmentCountVisible
                      ? classes.attachmentCounterVisible
                      : classes.attachmentCounterHidden
                  }`}
                >{`${attachmentIndex + 1}/${attachmentSize}`}</div>
              ) : null}
              {showDownloadBeginOverlay && (
                <div
                  onClick={e => e.stopPropagation()}
                  className={downloadBeginOverlayClass}
                >
                  <div className={classes.downloadBeginText}>
                    <Trans i18nKey="journal:download_begin_shortly">
                      {"Your download will begin shortly. "}
                      <span
                        className={classes.clickHereText}
                        onClick={() => this.startDownloadFile({ attachment })}
                        style={{ cursor: "pointer" }}
                      >
                        {"Click here"}
                      </span>
                      {" to download again"}
                    </Trans>
                  </div>
                </div>
              )}
            </div>
          </ScalableView>
        );
        break;
      case "NOTE": {
        const noteHeight = Math.min(imageMaxHeight, sourceHeight) - 32;
        const numOfLines = Math.floor(noteHeight / 22);

        const isNewNoteUi = isNewNotesUi();

        const textHeight = _.size(_.get(attachment, "title")) / 28;
        const isTheatreMode = this.props.isTheatreMode;
        const shouldShowSeeMore = textHeight > 22 && !isTheatreMode;

        const webKitStyles = {
          WebkitLineClamp: numOfLines,
          ...noteContainerWithLimitStyles,
        };
        isNewNoteUi
          ? (mediaToRender = (
              <div
                tabIndex={0}
                className={classes.noteWrapper}
                style={{
                  height: noteHeight + 32,
                  width: imageMaxWidth,
                  padding: this.props.cardType === "small" ? "0px" : "16px",
                  ...updatedItemStyles,
                  backgroundColor: colors.white,
                  ...containerStyle,
                  ...noteContainerStyle,
                }}
              >
                <div
                  className={classes.noteLinesContainerV2}
                  style={{ ...noteLinesContainerStyles }}
                >
                  <div
                    style={webKitStyles}
                    className={classes.noteContainerWithLimitV2}
                    dangerouslySetInnerHTML={{
                      __html: getStyleStrippedText({
                        text: getCommentDisplayContent(
                          _.get(attachment, "title")
                        ),
                        type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                      }),
                    }}
                    data-test-id="note-content"
                  />
                  {shouldShowSeeMore && (
                    <div className={classes.seeMoreContainer}>
                      <Button variant="link-progressive" size="small">
                        {this.props.t("common:see_more_noDots")}
                      </Button>
                    </div>
                  )}
                  <div className={classes.notesOverlayContainer}>
                    {this.renderIconContainer(attachment)}
                  </div>
                </div>
              </div>
            ))
          : (mediaToRender = (
              <div
                tabIndex={0}
                className={classes.noteWrapper}
                style={{
                  height: noteHeight + 32,
                  width: imageMaxWidth,
                  padding: this.props.cardType === "small" ? "0px" : "16px",
                  ...updatedItemStyles,
                  backgroundColor: colors.white,
                  ...containerStyle,
                  ...noteContainerStyle,
                }}
              >
                <div
                  className={classes.noteLinesContainer}
                  style={{ ...noteLinesContainerStyles }}
                >
                  <div
                    style={{
                      WebkitLineClamp: numOfLines,
                      ...noteContainerWithLimitStyles,
                    }}
                    className={classes.noteContainerWithLimit}
                    dangerouslySetInnerHTML={{
                      __html: getStyleStrippedText({
                        text: getCommentDisplayContent(
                          _.get(attachment, "title")
                        ),
                        type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                      }),
                    }}
                    data-test-id="note-content"
                  />
                  <div className={classes.notesOverlayContainer}>
                    {this.renderIconContainer(attachment)}
                  </div>
                </div>
              </div>
            ));
        break;
      }
      default:
        break;
    }
    return mediaToRender;
  };

  getDetailsOfFileUploadedAsLink = (attachmentMimeType, attachmentMetaData) => {
    switch (attachmentMimeType) {
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/vnd.google-apps.document":
        return {
          cornerTagIcon: this.getIconByFileType({
            fileType: _.upperCase(attachmentMetaData),
            fileIconSize: "x-small",
          }),
          cornerTagfileType: _.capitalize(attachmentMetaData),
        };
      case "application/vnd.ms-excel":
      case "application/vnd.google-apps.spreadsheet":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return {
          cornerTagIcon: this.getIconByFileType({
            fileType: "SHEET",
            fileIconSize: "x-small",
          }),
          cornerTagfileType: _.capitalize("SHEET"),
        };
      case "application/pdf":
        return {
          cornerTagIcon: this.getIconByFileType({
            fileType: "PDF",
            fileIconSize: "x-small",
          }),
          cornerTagfileType: "PDF",
        };
    }
  };

  getCornerTagDetails = attachment => {
    const attachmentMimeType = _.get(attachment, "mimeType");
    const attachmentType = _.get(attachment, "type");
    const attachmentMetaData = _.get(
      attachment,
      "metadata.fileType",
      "DOCUMENT"
    );
    if (attachmentType == "LINK" && !attachmentMimeType) {
      return {
        cornerTagfileType: _.capitalize(attachmentType),
        cornerTagIcon: this.getIconByFileType({
          fileType: "LINK",
          fileIconSize: "x-small",
        }),
      };
    }

    if (attachmentType == "NOTE") return null;
    let { fileType } = getFileThumbUrl(attachmentMimeType);
    if (_.includes(["LINK", "NOTE", "WORKBOOK"], attachmentType))
      fileType = attachmentType;

    const icon = this.getIconByFileType({ fileType, fileIconSize: "x-small" });
    if (
      fileType === "LINK" &&
      _.includes(["document", "file"], _.lowerCase(attachmentMetaData))
    ) {
      return this.getDetailsOfFileUploadedAsLink(
        attachmentMimeType,
        attachmentMetaData
      );
    }

    return {
      cornerTagfileType: fileType == "PDF" ? fileType : _.capitalize(fileType),
      cornerTagIcon: icon,
    };
  };
  renderIconContainer = attachment => {
    const centerIconDiv = this.getCenterSvgDetails(attachment);
    const attachmentActionsSvgs = this.attachmentActionsSvgs(attachment);
    const {
      showOverlayIcons,
      iconContainerStyle,
      mode,
      showMiddleContainerIcons,
      postEntityItems,
      showExtensionOnCornerByHover,
      extensionTagSize = "x-small",
      getCurrentAssessmentTypes,
      setWorkbookMode,
      isWorkbook,
      t,
      isMobileDevice,
    } = this.props;
    if (mode === "select") return null;

    const { assessmentType } = getStudentResponseData(postEntityItems);

    const showEmbedPlayButton =
      _.get(attachment, "type", "") === "LINK" &&
      ReactPlayer.canPlay(_.get(attachment, "url", ""));
    const currentAssessmentTypes = getCurrentAssessmentTypes();
    const Icon = _.get(currentAssessmentTypes[assessmentType], "icon", null);
    const cornerTagDetails = this.getCornerTagDetails(attachment);
    return (
      <React.Fragment>
        {showExtensionOnCornerByHover &&
          !_.isNil(cornerTagDetails) &&
          !(isWorkbook && mode === "edit") && (
            <div
              className={classes.cornerTagExtensionContainer}
              style={
                isMobileDevice ? styles.attachmentMediaStyle : BLANK_OBJECT
              }
            >
              <Tag
                size={extensionTagSize}
                prefix={_.get(cornerTagDetails, "cornerTagIcon")}
              >
                {_.get(cornerTagDetails, "cornerTagfileType")}
              </Tag>
            </div>
          )}
        {isWorkbook && mode === "edit" && (
          <div>
            <Button
              variant="outlined-subtle"
              size="small"
              onClick={e => {
                e.stopPropagation();
                setWorkbookMode("USE_TEMPLATE");
              }}
              icon={<PencilLineOutlined />}
              className={classes.topCornerEditWorkBookButton}
            >
              {t("common:edit")}
            </Button>
          </div>
        )}
        {showMiddleContainerIcons && assessmentType && !_.isNil(Icon) ? (
          <div
            className={classes.assessmentOverlay}
            style={{
              ...(!showOverlayIcons ? { display: "flex" } : {}),
            }}
          >
            <div className={classes.assessmentOverlayCircle}>
              <Icon className={classes.assessmentIcon} size={"xx-small"} />
            </div>
          </div>
        ) : (
          !(
            attachment.type == "IMAGE" ||
            attachment.type == "FILE" /*&& !attachment.thumbUrl */ ||
            attachment.type == "NOTE"
          ) &&
          (showMiddleContainerIcons || showEmbedPlayButton) && (
            <div
              className={classes.middleIconContainer}
              style={{
                ...iconContainerStyle,
                ...(!showOverlayIcons || showEmbedPlayButton
                  ? { display: "flex" }
                  : {}),
              }}
            >
              {centerIconDiv}
            </div>
          )
        )}
        {!!showOverlayIcons && !showEmbedPlayButton && (
          <React.Fragment>
            <div className={classes.overlay} />
            {attachmentActionsSvgs}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  getCardType = () => {
    const { imageMaxWidth } = this.props;
    return imageMaxWidth > 340 ? "large" : "small";
  };

  onCarouselItemClick = (event, index) => {
    const { onClickMedia } = this.props;
    if (onClickMedia) {
      event.stopPropagation();
      onClickMedia({ activeIndex: index, event });
    }
  };

  renderCarouselImageV2 = ({ item, index }) => {
    const { thumbUrl, fileType } = getThumbUrl({
      ...this.getThumbResolution({
        imageMaxWidth: _.get(this.props, "imageMaxWidth", 520),
        imageHeight: 400,
        resolutionMutliplier: 1,
        fitIn: false,
      }),
      attachment: item,
      fitIn: false,
    });

    const {
      imageMaxWidth,
      imageMaxHeight,
      scalableRatio,
      containerStyle,
      showBorderOnHover,
      backgroundSize,
      itemStyles,
    } = this.props;

    const imageHeight = imageMaxHeight;
    const updatedItemStyles = itemStyles;

    const imageContainerClass = classNames(
      { [classes.imageContainer]: true },
      { [classes.borderOnHover]: showBorderOnHover }
    );

    return (
      <div
        key={_.get(item, "id", _.get(item, "url", ""))}
        onClick={e => this.onCarouselItemClick(e, index)}
        style={{ width: "100%" }}
      >
        <ScalableView
          width={imageMaxWidth}
          height={imageHeight}
          sourceWidth={_.get(item.metadata, "width", 556) || 556}
          sourceHeight={_.get(item.metadata, "height", 288) || 288}
          scalableRatio={scalableRatio}
          containerStyle={containerStyle}
        >
          {_.isEqual(item?.type, "FILE") ? (
            this.getIconCardByFileType({
              fileType,
              itemStyles: updatedItemStyles,
              containerStyle,
            })
          ) : (
            <div
              style={{
                backgroundImage: `url('${thumbUrl}')`,
                backgroundSize,
                height: `${imageHeight}px`,
                ...updatedItemStyles,
              }}
              className={imageContainerClass}
            >
              {this.renderIconContainer(item)}
            </div>
          )}
        </ScalableView>
      </div>
    );
  };
  renderCarouselImage = ({ item, index }) => {
    const {
      imageMaxWidth,
      imageMaxHeight,
      attachments,
      itemContainerStyle,
    } = this.props;
    const { thumbUrl } = getThumbUrl({
      ...this.getThumbResolution({
        imageMaxWidth,
        imageHeight: imageMaxHeight,
        resolutionMutliplier: 2,
        fitIn: true,
      }),
      attachment: item,
      fitIn: true,
    });
    const cardType = this.getCardType();
    const containerStyle = classNames(
      { [classes.carouselImageContainer]: cardType == "large" },
      { [classes.smallCarouselImageContainer]: cardType == "small" }
    );

    const altText = _.get(item, "name", "") ?? "";

    return (
      <div
        key={_.get(item, "id", _.get(item, "url", ""))}
        onClick={e => this.onCarouselItemClick(e, index)}
      >
        <div
          className={containerStyle}
          style={{
            height: cardType == "small" ? imageMaxHeight : "100%",
            maxWidth:
              cardType == "small"
                ? "100%"
                : imageMaxWidth *
                  (index < _.get(attachments, "length", 0) - 1 ? 0.8 : 1),
            overflow: "hidden",
            ...itemContainerStyle,
          }}
        >
          <img
            src={thumbUrl}
            style={{ height: imageMaxHeight }}
            width={"100%"}
            alt={altText}
          />
          {this.renderIconContainer(item)}
          {cardType == "small" && (
            <div
              className={classes.counterText}
              style={{ top: imageMaxHeight - 24 }}
            >
              {`${index + 1}/${_.get(attachments, "length", 0)}`}
            </div>
          )}
        </div>
      </div>
    );
  };

  renderAudioCaptionAttachmentList = attachments => {
    const { audioCaptionContainerStyles } = this.props;
    const audioAttachmentsCount = getAttachmentsByTypeFromAttachmentArr({
      attachmentsArr: _.get(attachments, "attachments"),
      type: "AUDIO",
    }).length;
    const isOnlyAudioAttachmentPresent =
      _.get(attachments, "attachments.length", 0) === audioAttachmentsCount;

    return !isOnlyAudioAttachmentPresent ? (
      <AttachmentList
        value={getAttachmentsByTypeFromAttachmentArr({
          attachmentsArr: _.get(attachments, "attachments"),
          type: "AUDIO",
        })}
        name={"attachments"}
        cardType={"horizontal"}
        showCreateDropdown={false}
        parentId={""}
        mode={"view"}
        parentType={""}
        attachmentContainerStyle={{
          gridTemplateColumns: "unset",
          margin: "8px 0px",
          ...audioCaptionContainerStyles,
        }}
        showAudioDownloadButton={this.props.showAudioDownloadButton}
      />
    ) : null;
  };

  renderMedia = () => {
    const {
      attachments,
      imageMaxHeight,
      carouselContainerStyle,
      hasAudioCaption,
      postEntityItems,
      showOverlayIcons,
      showCarouselV2,
      showDeleteIconOnTopCorner = false,
      isAttachmentCreated,
      mode,
      deleteButtonVariant = "x-small",
      getCurrentAssessmentTypes,
      showDeleteButtonOnCreateMode,
      customDeleteButtonStyle,
      toggleEditAttachmentModal,
      activatorNodeRef,
      listeners,
      reorderTooltip,
      deleteIconTooltip,
      deleteIconLegacyVariant = "outlined-subtle",
      deleteIconVariant = "neutral",
      deleteIconType = "outlined",
      testId,
    } = this.props;

    const {
      itemId,
      assessmentType,
      studentResponseAttachments,
    } = getStudentResponseData(postEntityItems);
    const attachment =
      _.get(attachments, "length", 0) > 0 ? attachments[0] : null;
    const studentResponseAttachment =
      _.get(studentResponseAttachments, "length", 0) > 0
        ? studentResponseAttachments[0]
        : null;

    let media = null;
    const cardType = this.getCardType();
    const isImageCarousel = _.filter(attachments, { type: "IMAGE" }).length > 1;
    const currentAssessmentTypes = getCurrentAssessmentTypes();

    if (assessmentType && _.isEmpty(studentResponseAttachments)) {
      const Icon = _.get(currentAssessmentTypes[assessmentType], "icon", null);
      const attachmentActionsSvgs = this.attachmentActionsSvgs([]);
      return (
        <React.Fragment>
          <div
            className={classes.assessmentPlaceholderOverlay}
            style={{
              backgroundImage: `url(${
                PLACEHOLDER_RECT_IMAGE[
                  (itemId || 0) % PLACEHOLDER_RECT_IMAGE_COUNT
                ]
              })`,
            }}
          >
            <div
              className={classes.assessmentOverlayCircle}
              style={{ ...(!showOverlayIcons ? { display: "flex" } : {}) }}
            >
              {!_.isUndefined(Icon) ? (
                <Icon className={classes.assessmentIcon} size={"xx-small"} />
              ) : null}
            </div>
          </div>
          {!!showOverlayIcons && (
            <React.Fragment>
              <div className={classes.overlay} />
              {attachmentActionsSvgs}
            </React.Fragment>
          )}
        </React.Fragment>
      );
    }
    if (isImageCarousel && !assessmentType) {
      if (showCarouselV2) {
        media = (
          <React.Fragment>
            {hasAudioCaption ? (
              <div className={classes.audioContainer}>
                {this.renderAudioCaptionAttachmentList({ attachments })}
              </div>
            ) : null}
            <div>
              <SlickSlider
                items={_.filter(attachments, ({ type }) => type !== "AUDIO")}
                renderItem={this.renderCarouselImageV2}
                variableWidth={cardType == "large"}
                showDots={cardType == "large"}
                containerStyle={{ paddingBottom: "25px" }}
              />
            </div>
          </React.Fragment>
        );
      } else {
        const containerStyle = classNames(
          {
            [classes.carouselContainer]: cardType == "large",
          },
          { [classes.smallCarouselContainer]: cardType == "small" }
        );
        let customPrevArrowStyle = {};
        let customNextArrowStyle = {};
        let customArrowIconContainerStyle = {};
        if (cardType == "small" && imageMaxHeight && imageMaxHeight > 0) {
          const arrowStyle = {
            width: 20,
            height: 20,
            borderRadius: 10,
            border: "solid 0.5px #424b5d",
            backgroundColor: "rgba(32, 38, 50, 0.9)",
          };
          customPrevArrowStyle = {
            ...arrowStyle,
            top: imageMaxHeight - 20,
            left: "unset",
            right: 40,
          };
          customNextArrowStyle = {
            ...arrowStyle,
            top: imageMaxHeight - 20,
            left: "unset",
            right: 12,
          };
          customArrowIconContainerStyle = {
            fill: "white",
            width: 8,
            height: 8,
          };
        }
        media = (
          <React.Fragment>
            {hasAudioCaption ? (
              <div className={classes.audioContainer}>
                {this.renderAudioCaptionAttachmentList({ attachments })}
              </div>
            ) : null}
            <div className={containerStyle} style={carouselContainerStyle}>
              <SlickSlider
                items={_.filter(attachments, ({ type }) => type !== "AUDIO")}
                renderItem={this.renderCarouselImage}
                customPrevArrowStyle={customPrevArrowStyle}
                customNextArrowStyle={customNextArrowStyle}
                variableWidth={cardType == "large"}
                showDots={cardType == "large"}
                customArrowIconContainerStyle={customArrowIconContainerStyle}
              />
            </div>
          </React.Fragment>
        );
      }
    } else if (attachment || studentResponseAttachment) {
      const audioAttachment =
        hasAudioNote({ attachments }) && !hasAudioCaption
          ? attachments[1]
          : null;
      media = (
        <React.Fragment>
          {hasAudioCaption
            ? this.renderAudioCaptionAttachmentList({ attachments })
            : null}
          {this.getMediaRender(
            attachment ? attachment : studentResponseAttachment
          )}
          {audioAttachment ? (
            cardType == "large" ? (
              <div className={classes.audioNote}>
                <AudioPlayer
                  attachment={audioAttachment}
                  mediaType={"secondary"}
                ></AudioPlayer>
              </div>
            ) : (
              !assessmentType && (
                <div className={classes.smallAudioNote}>
                  <SpeakerIcon width={10} height={10}></SpeakerIcon>
                </div>
              )
            )
          ) : null}
          {showDeleteButtonOnCreateMode ? (
            <div
              className={classes.cornerIconContainer}
              ref={activatorNodeRef}
              {...listeners}
            >
              <Tooltip tooltip={reorderTooltip} showArrow={true}>
                <IconButton
                  _legacy_variant="outlined-subtle"
                  variant="neutral"
                  type="outlined"
                  size="small"
                  onClick={e => {
                    e.stopPropagation();
                    toggleEditAttachmentModal && toggleEditAttachmentModal();
                  }}
                  icon={<MoveArrowsOutlined />}
                  className={classes.topCornerAddImageButton}
                />
              </Tooltip>
            </div>
          ) : null}
          {showDeleteIconOnTopCorner && isAttachmentCreated && mode == "edit" && (
            <ConditionalWrapper
              condition={_.size(deleteIconTooltip)}
              type={"wrapperAsElement"}
              wrapper={<Tooltip tooltip={deleteIconTooltip} showArrow={true} />}
            >
              <IconButton
                icon={<DeleteOutlined />}
                testId={`${testId}-mediaDelete`}
                size={deleteButtonVariant}
                variant={deleteIconVariant}
                _legacy_variant={deleteIconLegacyVariant}
                type={deleteIconType}
                onClick={e => {
                  e?.stopPropagation();
                  this.onDeleteClick(
                    attachment ? attachment : studentResponseAttachment
                  );
                }}
                className={classes.topCornerDeleteButton}
                style={customDeleteButtonStyle}
              />
            </ConditionalWrapper>
          )}
        </React.Fragment>
      );
    }

    return media;
  };

  isShowVideoPlayer = () => {
    const { attachments, showVideoPlayer } = this.props;
    const attachmentType = _.get(_.first(attachments), "type", "");
    return attachmentType == "VIDEO" && showVideoPlayer;
  };

  onClickMedia = event => {
    event.stopPropagation();
    const { onClickMedia } = this.props;
    if (onClickMedia) {
      onClickMedia({ event });
    }
  };

  isAudioAttachment = () => {
    const { attachments } = this.props;
    const attachment =
      _.get(attachments, "length", 0) > 0 ? attachments[0] : null;
    const attachmentType = _.get(attachment, "type", "");

    return attachmentType === "AUDIO";
  };

  toggleAudio = () => {
    this._audioPlayerRef?.toggleAudio();
  };

  handleClick = event => {
    const {
      attachments,
      isDisabledMode,
      isUploading,
      isLastAttachment,
      isStudentResponse,
      showIconCardsWithExtension,
      showAudioWaveformPlayerV2,
      showCompactAudioWaveformPlayer,
    } = this.props;

    if (showAudioWaveformPlayerV2 || showCompactAudioWaveformPlayer) return;
    const disableOnClickMedia =
      !isStudentResponse &&
      (isImageCarousel({ attachments }) ||
        this.isShowVideoPlayer() ||
        isDisabledMode ||
        (this.isAudioAttachment() && !showIconCardsWithExtension));

    disableOnClickMedia ? null : this.onClickMedia(event);

    this.isAudioAttachment() &&
      !(isUploading && isLastAttachment) &&
      this.toggleAudio();
  };

  preventDefaultOnKeydown =
    !this.props.showAudioWaveformPlayerV2 &&
    !this.props.showCompactAudioWaveformPlayer;

  handleContainerKeyDown = e =>
    onEnterOrSpaceKeyDown(e, this.handleClick, this.preventDefaultOnKeydown);

  render() {
    return (
      <div
        className={classes.container}
        style={this.props.containerStyle}
        onClick={this.handleClick}
        onKeyDown={this.handleContainerKeyDown}
      >
        {this.renderMedia()}
      </div>
    );
  }
}

MediaPlaceholder.defaultProps = {
  imageMaxHeight: 512,
  imageMaxWidth: 512,
  attachments: [],
  resolutionMutliplier: 1,
  fitIn: true,
  backgroundSize: "cover",
  scalableRatio: 0,
  iconContainerStyle: {},
  itemContainerStyle: {},
  carouselContainerStyle: {},
  containerStyle: {},
  showOverlayIcons: false,
  mode: "view",
  showDownloadIcon: true,
  showVideoPlayer: false,
  showFullscreenImage: false,
  isDisabledMode: false,
  showLinkInNewTab: false,
  showMiddleContainerIcons: true,
  hasAudioCaption: false,
  audioCaptionContainerStyles: {},
  noteContainerWithLimitStyles: {},
  noteContainerStyle: {},
  isAttachmentCreated: true,
  showDownloadBeginOverlay: false,
  isUploading: false,
  isLastAttachment: false,
  isStudentResponse: false,
  showCarouselV2: false,
  showIconCardsWithExtension: false,
  fileIconSize: "large",
  extensionTextStyle: {},
  showExtensionOnCornerByHover: false,
  noteLinesContainerStyles: {},
  showVideoPlayerV2: false,
  useLazyVideoPlayer: false,
  isolateSpacebarControl: false,
  showAudioDownloadButton: true,
  customDeleteButtonStyle: {},
  testId: "UIComponents-mediaPlaceholder",
  isDownloadEnabled: true,
  showCompactAudioWaveformPlayer: false,
  isAppearanceLikeMediaCard: false,
  playAudioOnSeek: false,
  shouldBeResponsive: false,
  isTheatreMode: false,
};

MediaPlaceholder.propTypes = {
  imageMaxHeight: PropTypes.number,
  attachments: PropTypes.array,
  onClickMedia: PropTypes.func,
  resolutionMutliplier: PropTypes.number,
  fitIn: PropTypes.bool,
  backgroundSize: PropTypes.string,
  scalableRatio: PropTypes.number,
  containerStyle: PropTypes.object,
  showOverlayIcons: PropTypes.bool,
  mode: PropTypes.string,
  deleteAttachment: PropTypes.func,
  showDownloadIcon: PropTypes.bool,
  showVideoPlayer: PropTypes.bool,
  showFullscreenImage: PropTypes.bool,
  isDisabledMode: PropTypes.bool,
  showLinkInNewTab: PropTypes.bool,
  hasAudioCaption: PropTypes.bool,
  audioCaptionContainerStyles: PropTypes.object,
  isAttachmentCreated: PropTypes.bool,
  showDownloadBeginOverlay: PropTypes.bool,
  isUploading: PropTypes.bool,
  isLastAttachment: PropTypes.bool,
  isStudentResponse: PropTypes.bool,
  showCarouselV2: PropTypes.bool,
  showIconCardsWithExtension: PropTypes.bool,
  fileIconSize: PropTypes.string,
  extensionTextStyle: PropTypes.object,
  showExtensionOnCornerByHover: PropTypes.bool,
  noteLinesContainerStyles: PropTypes.object,
  showVideoPlayerV2: PropTypes.bool,
  useLazyVideoPlayer: PropTypes.bool,
  isolateSpacebarControl: PropTypes.bool,
  showAudioDownloadButton: PropTypes.bool,
  customDeleteButtonStyle: PropTypes.object,
  testId: PropTypes.string,
  isDownloadEnabled: PropTypes.bool,
  showCompactAudioWaveformPlayer: PropTypes.bool,
  isAppearanceLikeMediaCard: PropTypes.bool,
  playAudioOnSeek: PropTypes.bool,
  shouldBeResponsive: PropTypes.bool,
  isTheatreMode: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const isMobileDevice = isTouchableV2();
  return { isMobileDevice };
};

const mapActionCreators = {
  downloadFromUrl,
  removeProgressElement,
  getCurrentAssessmentTypes,
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["common", "journal", "a11y"] })
)(MediaPlaceholder);
